angular.module('virtoCommerce.marketplaceModule')
    .controller('virtoCommerce.marketplaceModule.sellerCategoriesWidgetController', ['$scope', 'platformWebApp.bladeNavigationService', 'virtoCommerce.marketplaceModule.webApi', 'virtoCommerce.catalogModule.listEntries',
        function ($scope, bladeNavigationService, marketplaceApi, listEntriesApi) {
            var sellerId = $scope.widget.blade.currentEntity.id;

            function refresh() {
                var searchCriteria = {
                    catalogId: sellerId,
                    objectTypes: ['Category'],
                    skip: 0,
                    take: 0
                };

                listEntriesApi.listitemssearch(searchCriteria, function(data) {
                    $scope.categoriesCount = data.totalCount;
                });
            }

            $scope.openBlade = function () {
                marketplaceApi.getSettings((data) => {
                    var newBlade = {
                        id: 'seller-category-list',
                        level: 0,
                        sellerId: sellerId,
                        masterCatalogId: data.masterCatalogId,
                        catalogId: sellerId,
                        breadcrumbs: [],
                        parentWidgetRefresh: refresh,
                        title: "marketplace.widgets.seller-categories.seller-catalog",
                        controller: 'virtoCommerce.marketplaceModule.sellerCategoryListController',
                        template: 'Modules/$(VirtoCommerce.Catalog)/Scripts/blades/categories-items-list.tpl.html'
                    };

                    bladeNavigationService.showBlade(newBlade, $scope.widget.blade);
                });
            };

            refresh();
        }
]);
